export default __webpack_public_path__ + "static/media/remarkable.18649e2f.png";